import { FieldProps, FormControl, useFormField } from '@core/utils/form';
import { R } from '@core/utils/r';
import MFormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Label } from 'reactstrap';
import { FormSelectBaseProps, FormSelectItem } from './FormSelect';

export interface FormToggleInputProps<T extends string[]> extends FormSelectBaseProps<T>, FieldProps<FormControl<T>> {
  items: FormSelectItem<T[0]>[];
}

export function FormToggleInput<T extends string[]>(props: FormToggleInputProps<T>) {
  const { formControl, fieldState, fieldConfig } = useFormField(props);

  const fieldTouched = (fieldState && fieldState.touched) || formControl.inheritedSubmitted || false;
  const fieldError = (fieldTouched && fieldState.errorMessage) || null;

  const fieldValue = R.isNil(fieldState.value) ? [] : fieldState.value;

  const content = (
    <React.Fragment>
      <Label style={props.horizontal ? { marginBottom: 0, marginRight: 10 } : {}}>{fieldConfig.label}</Label>
      <MFormControl error={!!fieldError} fullWidth style={props.style}>
        <div className="btn-group btn-group-toggle mr-4" data-toggle="buttons">
          {props.items.map((item, index) => (
            <label key={index} className={fieldValue.includes(item.value) ? 'btn btn-primary active' : 'btn btn-light'}>
              <input
                type="radio"
                name="options"
                id={`option${index}`}
                onClick={() => {
                  if (fieldValue.includes(item.value)) {
                    formControl.setValue(fieldValue.filter((v: string) => v !== item.value));
                  } else {
                    formControl.setValue([...fieldValue, item.value] as any);
                  }
                }}
              />{' '}
              {item.label}
            </label>
          ))}
        </div>

        {!!fieldError && <FormHelperText>{fieldError}</FormHelperText>}
      </MFormControl>
    </React.Fragment>
  );

  if (props.withoutGroup) return content;
  return (
    <div className={`${props.horizontal ? 'd-flex align-items-center ' : 'form-group'}`} style={props.style}>
      {content}
    </div>
  );
}
